/* ZYMA product record tabs — sections/zyma-product-records.liquid (layout: tabs)
   Click or arrow keys switch products (arrows follow reading direction); the editor opens the selected block's tab. */
(() => {
  if (customElements.get('zyma-record-tabs')) return;

  class ZymaRecordTabs extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });
      this.onBlockSelect = (event) => {
        const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail?.blockId);
        if (index > -1) this.select(index);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !active;
      });
      if (focus) {
        this.tabs[index].focus();
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    }

    onKeydown(event, index) {
      const rtl = getComputedStyle(this).direction === 'rtl';
      const last = this.tabs.length - 1;
      let target = null;
      if (event.key === (rtl ? 'ArrowLeft' : 'ArrowRight')) target = index === last ? 0 : index + 1;
      else if (event.key === (rtl ? 'ArrowRight' : 'ArrowLeft')) target = index === 0 ? last : index - 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = last;
      if (target === null) return;
      event.preventDefault();
      this.select(target, true);
    }
  }

  customElements.define('zyma-record-tabs', ZymaRecordTabs);
})();
